<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between flex-wrap">
  <div class="flex align-items-center justify-content-center">
    <p-breadcrumb [model]="pageVars.breadcrumbItems">
      <ng-template let-item let-last="last" let-first="first" pTemplate="item">
        <ng-container *ngIf="!first">
          <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
          <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
        </ng-container>
      </ng-template>
    </p-breadcrumb>
  </div>

  <div class="flex align-items-center justify-content-center">
    <p-button icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)" pTooltip="Reset Table" tooltipPosition="bottom"></p-button>
    <p-button icon="pi pi-filter-slash" [raised]="true" *ngIf="filtersActive" (click)="clearFilters(dt)" pTooltip="Clear Filter/Sort" tooltipPosition="bottom"></p-button>
  </div>
</div>

<p-table
  #dt
  [value]="orders"
  [columns]="cols"
  [reorderableColumns]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [paginator]="true"
  [first]="skip"
  [rows]="take"
  [totalRecords]="totalCount"
  [filterDelay]="300"
  [lazy]="true"
  (onLazyLoad)="handleTableEvents($event)"
  sortField="OrderSequence"
  stateKey="approve-orders-table"
  stateStorage="local"
  [scrollable]="true"
  scrollHeight="60vh">

  <ng-template #header let-columns>
    <tr>
      <th
        *ngFor="let col of columns"
        pResizableColumn
        pReorderableColumn
        [pSortableColumn]="col.field"
        [ngStyle]="getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter [type]="col.type" [field]="col.field" placeholder="Filter.." display="menu" class="ml-1" [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined"></p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-order let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'approve']">
            {{ order[col.field] }}
          </a>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ order[col.field] }}
          </div>
          <ng-container *ngSwitchDefault>
            {{ order[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length">No orders found.</td>
    </tr>
  </ng-template>
</p-table>
